import React from 'react';
import { Button } from 'antd';
import { AppstoreOutlined } from '@ant-design/icons';
import '../styles/course-list.css';

export function CategoryFilter({ categories = [], selectedCategoryId, onSelectCategory }) {
  return (
    <div className="category-filter-scroll">
      <Button
        type={!selectedCategoryId ? 'primary' : 'default'}
        icon={<AppstoreOutlined />}
        onClick={() => onSelectCategory(null)}
        className="category-filter-btn"
        style={{ borderRadius: 20 }}
      >
        Tất cả chuyên đề
      </Button>

      {categories.map((cat) => {
        const isSelected = selectedCategoryId === cat.id;
        return (
          <Button
            key={cat.id}
            type={isSelected ? 'primary' : 'default'}
            onClick={() => onSelectCategory(cat.id)}
            className="category-filter-btn"
            style={{
              borderRadius: 20,
              borderColor: isSelected ? undefined : '#e2e8f0',
            }}
          >
            {cat.name}
          </Button>
        );
      })}
    </div>
  );
}
